import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const CustomSpinner = ({
  text = "Loading...",
  color = "text-orange-500",
  children,
  isLoading,
}) => {
  const { t } = useTranslation();
  return (
    <div className="relative">
      {isLoading && (
        <div className="absolute inset-0 flex flex-col items-center justify-center bg-white bg-opacity-75 z-10">
          <div
            className={`animate-spin w-8 h-8 border-[3px] border-current border-t-transparent rounded-full ${color}`}
            role="status"
            aria-label="loading"
          >
            <span className="sr-only">{t("loading")}</span>
          </div>
          {text && <p className={`mt-2 ${color}`}>{t("loading")}</p>}
        </div>
      )}
      <div className={isLoading ? "opacity-50" : ""}>{children}</div>
    </div>
  );
};

CustomSpinner.propTypes = {
  text: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.node.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default CustomSpinner;
